import { AryaRoom } from '@digital-bridge/artisan-arya';
import { Position2D, Vector2D } from '@digital-bridge/fine';

const roomSize = 6;

export const basic: AryaRoom = {
    height: 0.001,
    vertices: [
        new Position2D(0, 0),
        new Position2D(0, roomSize),
        new Position2D(roomSize, roomSize),
        new Position2D(roomSize, 0),
    ]
        // center room on 0,0 (so naive furniture adding works)
        .map(p => p.translate(new Vector2D([-roomSize / 2, -roomSize / 2]))),
};
